import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SpoilerButtonIcon = (props) => {
  return props.newFormattingToolbar ? /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "12", viewBox: "0 0 16 12" }, props), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.886 4c4.616 0 7.225 4.395 7.7 5.277.246.452.246.993.002 1.446C17.11 11.604 14.502 16 9.886 16s-7.226-4.396-7.701-5.277c-.246-.453-.246-.994-.001-1.446C2.66 8.395 5.27 4 9.886 4zm0 1C5.838 5 3.493 8.958 3.064 9.752c-.085.158-.085.338 0 .496C3.493 11.041 5.837 15 9.886 15c4.049 0 6.392-3.959 6.822-4.752.085-.158.085-.338-.001-.496C16.277 8.959 13.935 5 9.886 5zm0 2c1.653 0 3 1.346 3 3s-1.347 3-3 3c-1.655 0-3-1.346-3-3s1.345-3 3-3zm0 1c-1.104 0-2 .897-2 2s.896 2 2 2c1.102 0 2-.897 2-2s-.898-2-2-2z",
      transform: "translate(-378.000000, -81.000000) translate(376.000000, 77.000000)"
    }
  ))))) : /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" }, props), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.886 4c4.616 0 7.225 4.395 7.7 5.277.246.452.246.993.002 1.446C17.11 11.604 14.502 16 9.886 16s-7.226-4.396-7.701-5.277c-.246-.453-.246-.994-.001-1.446C2.66 8.395 5.27 4 9.886 4zm0 1C5.838 5 3.493 8.958 3.064 9.752c-.085.158-.085.338 0 .496C3.493 11.041 5.837 15 9.886 15c4.049 0 6.392-3.959 6.822-4.752.085-.158.085-.338-.001-.496C16.277 8.959 13.935 5 9.886 5zm0 2c1.653 0 3 1.346 3 3s-1.347 3-3 3c-1.655 0-3-1.346-3-3s1.345-3 3-3zm0 1c-1.104 0-2 .897-2 2s.896 2 2 2c1.102 0 2-.897 2-2s-.898-2-2-2z",
      transform: "translate(-314 -433) translate(314 433)"
    }
  )))));
};

export { SpoilerButtonIcon as default };
//# sourceMappingURL=SpoilerButtonIcon.js.map
